import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CommercialHeader from './CommercialHeader';
import CommercialFooter from './CommercialFooter';
import './site.css';

// Revela elementos .cc-reveal ao entrarem na viewport.
function useReveal(dep) {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll('.cc-reveal'));
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach((el) => el.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      }),
      { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [dep]);
}

export default function SiteLayout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useReveal(pathname);

  return (
    <div className="cc">
      <CommercialHeader />
      <main className="cc-main">{children}</main>
      <CommercialFooter />
    </div>
  );
}
